import { useMemo } from "react";
import SearchablePopoverSelect from "@/shared/components/ui/Select/SearchablePopoverSelect";

const OWNER_CARD_TONES = [
  {
    avatar: "bg-sky-100 text-sky-700 dark:bg-sky-900/70 dark:text-sky-200",
  },
  {
    avatar: "bg-violet-100 text-violet-700 dark:bg-violet-900/70 dark:text-violet-200",
  },
  {
    avatar: "bg-amber-100 text-amber-700 dark:bg-amber-900/70 dark:text-amber-200",
  },
  {
    avatar: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/70 dark:text-emerald-200",
  },
  {
    avatar: "bg-rose-100 text-rose-700 dark:bg-rose-900/70 dark:text-rose-200",
  },
];

const OWNER_ROLE_LABELS = {
  user: "User",
  org_admin: "Org Admin",
  superadmin: "Super Admin",
};

const getOwnerTone = (value) => {
  const key = String(value || "owner");
  const hash = [...key].reduce(
    (total, character) => (total * 31 + character.charCodeAt(0)) >>> 0,
    0,
  );
  return OWNER_CARD_TONES[hash % OWNER_CARD_TONES.length];
};

const UserAssignDropdown = ({ contacts = [], onAssign, value = "" }) => {
  const options = useMemo(
      () =>
      contacts.map((contact) => {
        const tone = getOwnerTone(contact.id || contact.email || contact.name);
        const roleLabel = OWNER_ROLE_LABELS[contact.role] || contact.role || "";
        return {
          key: contact.id,
          title: contact.name,
          description: roleLabel,
          avatar: contact.avatar,
          avatarClassName: tone.avatar,
          searchText: `${contact.name} ${roleLabel}`,
        };
      }),
    [contacts],
  );

  const selectedKey = useMemo(() => {
    const match = contacts.find((contact) => contact.name === value);
    return match?.id ?? null;
  }, [contacts, value]);

  const handleSelect = (key) => {
    const contact = contacts.find((item) => item.id === key);
    if (!contact) return;

    onAssign?.({
      contact,
      name: contact.name,
    });
  };

  return (
    <SearchablePopoverSelect
      variant="user"
      options={options}
      selectedKey={selectedKey}
      onSelect={handleSelect}
      placeholderTitle="Assign Name"
      searchPlaceholder="Search User"
      emptyMessage="No users found"
      className="relative w-full"
      popoverClassName="w-[257px]"
      zIndex="z-[200]"
    />
  );
};

export default UserAssignDropdown;
